import styled from 'styled-components'

const SeparatorContainer = styled.div `
    width: 1px;
    height: 100%;
    display: inline-block;
    background-color: #F2F2F2;
`

const Separator = () => {
    return(
        <SeparatorContainer>

        </SeparatorContainer>
    )
}

export default Separator